"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _blocks = require("@wordpress/blocks");

var _richText = require("@wordpress/rich-text");

/**
 * WordPress dependencies
 */
const transforms = {
  from: [{
    type: 'block',
    isMultiBlock: true,
    blocks: ['core/paragraph'],
    transform: attributes => {
      return (0, _blocks.createBlock)('core/pullquote', {
        value: (0, _richText.toHTMLString)({
          value: (0, _richText.join)(attributes.map(_ref => {
            let {
              content
            } = _ref;
            return (0, _richText.create)({
              html: content
            });
          }), '\u2028'),
          multilineTag: 'p'
        }),
        anchor: attributes.anchor
      });
    }
  }, {
    type: 'block',
    blocks: ['core/heading'],
    transform: _ref2 => {
      let {
        content,
        anchor
      } = _ref2;
      return (0, _blocks.createBlock)('core/pullquote', {
        value: `<p>${content}</p>`,
        anchor
      });
    }
  }],
  to: [{
    type: 'block',
    blocks: ['core/paragraph'],
    transform: _ref3 => {
      let {
        value,
        citation
      } = _ref3;
      const paragraphs = [];

      if (value && value !== '<p></p>') {
        paragraphs.push(...(0, _richText.split)((0, _richText.create)({
          html: value,
          multilineTag: 'p'
        }), '\u2028').map(piece => (0, _blocks.createBlock)('core/paragraph', {
          content: (0, _richText.toHTMLString)({
            value: piece
          })
        })));
      }

      if (citation && citation !== '<p></p>') {
        paragraphs.push((0, _blocks.createBlock)('core/paragraph', {
          content: citation
        }));
      }

      if (paragraphs.length === 0) {
        return (0, _blocks.createBlock)('core/paragraph', {
          content: ''
        });
      }

      return paragraphs;
    }
  }, {
    type: 'block',
    blocks: ['core/heading'],
    transform: _ref4 => {
      let {
        value,
        citation,
        ...attrs
      } = _ref4;

      // If there is no pullquote content, use the citation as the
      // content of the resulting heading. A nonexistent citation
      // will result in an empty heading.
      if (value === '<p></p>') {
        return (0, _blocks.createBlock)('core/heading', {
          content: citation
        });
      }

      const pieces = (0, _richText.split)((0, _richText.create)({
        html: value,
        multilineTag: 'p'
      }), '\u2028');
      const headingBlock = (0, _blocks.createBlock)('core/heading', {
        content: (0, _richText.toHTMLString)({
          value: pieces[0]
        })
      });

      if (!citation && pieces.length === 1) {
        return headingBlock;
      }

      const quotePieces = pieces.slice(1);
      const pullquoteBlock = (0, _blocks.createBlock)('core/pullquote', { ...attrs,
        citation,
        value: (0, _richText.toHTMLString)({
          value: quotePieces.length ? (0, _richText.join)(pieces.slice(1), '\u2028') : (0, _richText.create)(),
          multilineTag: 'p'
        })
      });
      return [headingBlock, pullquoteBlock];
    }
  }]
};
var _default = transforms;
exports.default = _default;
//# sourceMappingURL=transforms.js.map